import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type SaveChapterProgressType = {
  chapterId: number | string;
  move_id?: number | string | null;
  completed?: boolean;
  // Practice mode only - see StudyChapterProgress.move_count/result on the backend.
  move_count?: number;
  result?: 'ongoing' | 'won' | 'lost' | 'drawn';
  // Take backs in this attempt. `attempts` and `best_result` are derived
  // server-side from the terminal result, so the client never sends them.
  takebacks_used?: number;
  hint_used?: boolean;
};

export default function useSaveChapterProgress() {
  return useMutation(async (payload: SaveChapterProgressType) => {
    const {chapterId, ...body} = payload;
    const response = await ChessRestClient.post(
      `/learning/study-chapter/${chapterId}/progress/save/`,
      body,
    );
    return response.data;
  });
}
